export enum TestingSessionStep {
  SETUP = 'Setup',
  CUSTOMER = 'Customer',
  TEST = 'Test',
  REVIEW = 'Review',
  COMPLETE = 'Complete',
}
export enum TestingSessionStatus {
  GOOD = 'OPEN',
  OK = 'CHECKED_IN',
}
